var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    [
      _c(
        "v-container",
        { staticClass: "bar lighten-2", attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            { attrs: { justify: "space-around", "no-gutters": "" } },
            [
              _c("AboutModal", {
                scopedSlots: _vm._u([
                  {
                    key: "clickable",
                    fn: function ({ on }) {
                      return [
                        _c(
                          "v-btn",
                          _vm._g({ attrs: { text: "", small: "" } }, on),
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("mdi-alpha-a-circle"),
                            ]),
                            _c(
                              "span",
                              { staticClass: "d-none d-sm-inline pl-3" },
                              [_vm._v("About")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("HelpModal", {
                scopedSlots: _vm._u([
                  {
                    key: "clickable",
                    fn: function ({ on }) {
                      return [
                        _c(
                          "v-btn",
                          _vm._g({ attrs: { text: "", small: "" } }, on),
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("mdi-help-circle"),
                            ]),
                            _c(
                              "span",
                              { staticClass: "d-none d-sm-inline pl-3" },
                              [_vm._v("Help")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c(
                "v-btn",
                {
                  attrs: {
                    href: _vm.repository + "/wiki",
                    target: "_blank",
                    text: "",
                    small: "",
                  },
                },
                [
                  _c("v-icon", { attrs: { small: "" } }, [
                    _vm._v("mdi-information"),
                  ]),
                  _c("span", { staticClass: "d-none d-sm-inline pl-3" }, [
                    _vm._v("Docs"),
                  ]),
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    href: _vm.repository,
                    target: "_blank",
                    text: "",
                    small: "",
                  },
                },
                [
                  _c("v-icon", { attrs: { small: "" } }, [
                    _vm._v("mdi-github"),
                  ]),
                  _c("span", { staticClass: "d-none d-sm-inline pl-3" }, [
                    _vm._v("Github"),
                  ]),
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    href: "https://www.netlify.com/",
                    target: "_blank",
                    text: "",
                    small: "",
                  },
                },
                [
                  _c("img", {
                    staticStyle: { width: "1.15rem", height: "1.15rem" },
                    attrs: {
                      src: require("@/assets/netlify-light.svg"),
                      alt: "Netlify.com",
                    },
                  }),
                  _c("span", { staticClass: "d-none d-sm-inline pl-3" }, [
                    _vm._v("Netlify"),
                  ]),
                ]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    href: _vm.repository + _vm.changelog,
                    target: "_blank",
                    text: "",
                    small: "",
                  },
                },
                [
                  _c("v-icon", { attrs: { small: "" } }, [
                    _vm._v("mdi-alpha-v-circle"),
                  ]),
                  _c("span", { staticClass: "d-sm-inline pl-3 text-center" }, [
                    _vm._v(_vm._s(_vm.version)),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }